/**
 * Export voor ontwerpers / image generators (ChatGPT, Midjourney, etc.).
 * Vorm: modern SaaS 2026, donker thema met blauwe accenten, geen logo-tekst in beeld.
 */

export const LANDING_IMAGE_SPECS = {
  heroVisual: {
    ratio: '4:3' as const,
    caption: 'Hero — dashboardgevoel',
    brief:
      'Abstracte illustratie: zachte isothermen over een gestileerde woning-silhouet, warme en koele zones in teal vs amber gloed, subtiele rasterlijnen, enterprise SaaS aesthetic, donkere achtergrond #0c0f14, accent #3d8bfd, geen interface-tekst.',
  },
  /** Sectie direct onder hero — bestand: `public/landing/landing-comfort-problem-radiator.png` (of hernoem naar landing-comfort-problem.png en pas landingAssets.ts aan). */
  comfortProblemVisual: {
    ratio: '4:3' as const,
    caption: 'Comfortprobleem — herkenbaar thuis',
    brief:
      'Semi-realistische moderne SaaS-illustratie: volwassene in rustige woonkamer bij radiator of raam — twijfel over warmte/kou/tocht, nadenkende houding. Organisch figuur (geen ronde cartoonkop). Aards palet (zand, klei, warm grijs, gedempt groen); één subtiel blauw accent (#3d8bfd) bv. kozijn of detail. Geen UI, schermen, grafieken of leesbare tekst. Zachte vlakken, geen harde zwarte contouren; illustratie op licht off-white paneel binnen het kader zodat het op donkere site leest.',
  },
  featureThermal: {
    ratio: '16:9' as const,
    caption: 'Warmte & koel inzichtelijk',
    brief:
      'Minimalistische UI-mockup (geen echte merknamen): staafgrafiek vermogen kW, thermische zones, zachte glow, glassmorphism card op dark background, professioneel en rustig.',
  },
  featureRooms: {
    ratio: '16:9' as const,
    caption: 'Per ruimte, per scenario',
    brief:
      'Isometrische of top-down schets van appartement met 3 kamers, elk een klein temperatuur-icoon, strak lijnwerk, duotone blauw-grijs, high-end product visual.',
  },
  featureReport: {
    ratio: '16:9' as const,
    caption: 'Rapport dat je meeneemt',
    brief:
      'Document-preview aesthetic: open rapportpagina met koppen en bulletpoints (blur/lorem), accentstreep blauw, vertrouwen en klaarheid, geen leesbare privédata.',
  },
  journeyStep: {
    ratio: '1:1' as const,
    caption: 'Stap in de reis',
    brief:
      'Pictogram-stijl: nummer in cirkel, pijl naar volgende stap, abstract huis + checklist, flat maar premium, dark mode.',
  },
} as const;
